String.prototype.splitHtml = function () {

  if (!this) return "";

  var original = this;
  var length = null;
  var overStr = "";
  var noHtmlLength = 0;
  if (arguments.length >= 1) {
    length = arguments[0];
    noHtmlLength = length;
  }
  if (arguments.length >= 2) {
    overStr = arguments[1];
  }



  var result = "";
  for (var i = 0; i < 10; i++) {
    if (result.ignoreHtml().length < noHtmlLength) {
      result = _splitHtml(result.length + (noHtmlLength - result.ignoreHtml().length), overStr, noHtmlLength);
    }
  }

  //添加省略号
  if (result != this) {
    result += overStr;
  }

  return result;

  //对于这两种情况，第二种情况可以无需特殊处理，但是第一种情况的话得将整个标签删除或者将其属性补全。删除的话
  //将字符串的末尾位置前移至标签开始之前；而补全则是将末尾位置后移至次标签的'>'处。这里采用的是删除的方法。
  function adjustByTagPostion (str) {
    var left_brace_index = str.lastIndexOf('<');
    var right_brace_index = str.lastIndexOf('>');
    // 为true的话则表示字符串处于第一种情况，需要进行删除操作。
    var inTagDefinition = left_brace_index > right_brace_index;
    return inTagDefinition ? str.substring(0, left_brace_index) : str;
  }

  // 将未闭合的标签按序闭合。
  function modifyDisplayString (original, addTags) {
    var tagLenth = addTags.length;
    for (var i = tagLenth - 1; i >= 0; i--) {
      original += '</' + addTags[i] + '>';
    }
    return original;
  }

  //分割函数
  function _splitHtml (length) {
    // 此数组用于保存那些未闭合的标签。
    var non_match_tag = []

    // 如果大于字符串的总长度，返回整个字符串；否则返回指定长度的子串
    var to = length >= original.length ? original.length : length;
    var substring = original.substring(0, to);
    //console.log(substring)

    //调整字符串。
    var adjustedSubString = adjustByTagPostion(substring);
    //console.log(adjustedSubString)

    var tag_pattern = /<\s*(\w+\b)(?:[^>]*[^\/])?>|<(\/\w+)>/ig
    adjustedSubString.replace(tag_pattern, function (match, $1, $2) {
      var value = !$1 ? (!$2 ? '' : $2) : $1;
      if (value.charAt(0) == '/') {
        // 为真表示这个标签是前面最后一个为闭合标签的闭合，因此，将此标签从数组中删除。
        if (non_match_tag.length > 0 && non_match_tag[non_match_tag.length - 1] == value.substring(1)) {
          non_match_tag.pop();
        }
      } else {
        // 新的未闭合的标签，将其添加到数组中。
        non_match_tag.push(value);
      }
    });

    var result = modifyDisplayString(adjustedSubString, non_match_tag);


    return result;
  }
}
String.prototype.ignoreHtml = function () {
  var result = this.toString();

  var clearHtmlStr = result.replace(/<[^>]+>/g, "");//去掉html标签
  result = clearHtmlStr.toString();


  if (arguments.length == 1) {
    result = result.substr(0, arguments[0]);
  }
  else if (arguments.length >= 2) {
    result = result.substr(arguments[0], arguments[1]); //切割字符串

    //添加后缀“...”
    if (arguments.length >= 3 && clearHtmlStr.length > (arguments[1] - arguments[0])) {
      result += arguments[2];
    }
  }
  return result;
};